export function LoadingSpinner() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-black">
      <div className="relative">
        <div className="w-16 h-16 border-4 border-[#9333EA]/20 border-solid rounded-full"></div>
        <div className="absolute top-0 left-0 w-16 h-16 border-4 border-[#9333EA] border-t-transparent animate-spin rounded-full"></div>
        <div className="mt-4 text-center text-[#9333EA] text-sm">Loading Report...</div>
      </div>
    </div>
  );
} 